import { render, staticRenderFns } from "./ReCheckMultiLanguage.vue?vue&type=template&id=0f681bf8"
import script from "./ReCheckMultiLanguage.vue?vue&type=script&lang=js"
export * from "./ReCheckMultiLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports